import { render, staticRenderFns } from "./Opmessageform.vue?vue&type=template&id=73401ac7&"
import script from "./Opmessageform.vue?vue&type=script&lang=js&"
export * from "./Opmessageform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports